import { ReactElement } from "react";

import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import ClinicWebsiteSubSection, { IClinicWebsiteSubSectionProps } from "./InfoInPortalSection/ClinicWebsiteSubSection";
import OfferedSpecialtiesSubSection, { IOfferedSpecialtiesSubSectionProps } from "./InfoInPortalSection/OfferedSpecialtiesSubSection";
import OpeningHoursSubSection, { IOpeningHoursSubSectionProps } from "./InfoInPortalSection/OpeningHoursSubSection";
import SiteDescriptionSubSection, { ISiteDescriptionSubSectionProps } from "./InfoInPortalSection/SiteDescriptionSubSection";
import SiteOnlineNameSubSection, { ISiteOnlineNameSubSectionProps } from "./InfoInPortalSection/SiteOnlineNameSubSection";

interface IInfoInPortalSectionProps extends
    IOfferedSpecialtiesSubSectionProps,
    IOpeningHoursSubSectionProps,
    IClinicWebsiteSubSectionProps,
    ISiteDescriptionSubSectionProps,
    ISiteOnlineNameSubSectionProps { }

const InfoInPortalSection: React.FC<IInfoInPortalSectionProps> = (props): ReactElement => {
    const {
        openingHours,
        specialties,
        offeredSpecialtyIds,
        localizedDisplayName,
        localizedWebsite,
        localizedDescription,
        localizedOpeningHoursNote,
        mutateState
    } = props;

    const { getText } = useTranslation();

    return (
        <div>
            <div className="view-section-header">
                <h3 className="view-section-title">{getText("ClinicInfo_InfoInPortalLabel")}</h3>
            </div>

            <div className="view-section-body">
                <label className="form-label">{getText("ClinicInfo_InfoInPortalDescription")}</label>
                <div className="row">
                    <div className="col-lg-4 col-md-2 col-sm-2 text-right" />
                </div>
                <SiteOnlineNameSubSection
                    localizedDisplayName={localizedDisplayName}
                    mutateState={mutateState}
                />
                <SiteDescriptionSubSection
                    localizedDescription={localizedDescription}
                    mutateState={mutateState}
                />
                <OpeningHoursSubSection
                    openingHours={openingHours}
                    localizedOpeningHoursNote={localizedOpeningHoursNote}
                    mutateState={mutateState}
                />
                <OfferedSpecialtiesSubSection
                    specialties={specialties}
                    offeredSpecialtyIds={offeredSpecialtyIds}
                    mutateState={mutateState}
                />
                <ClinicWebsiteSubSection
                    localizedWebsite={localizedWebsite}
                    mutateState={mutateState}
                />
            </div>
        </div>
    );
};

export default InfoInPortalSection;
